import React from 'react'

export default (props) => (
  <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect width='40' height='40' rx='4' fill='#31B76A' />
    <path fillRule='evenodd' clipRule='evenodd' d='M13 21.1429V26H19V21.1429H13ZM13 18.8572L19 18.8572V14H13V18.8572ZM21 21.1429V26H27V21.1429H21ZM27 18.8572L21 18.8572V14H27V18.8572ZM29 18.8572V13C29 12.4477 28.5523 12 28 12H12C11.4477 12 11 12.4477 11 13V27C11 27.5523 11.4477 28 12 28H28C28.5523 28 29 27.5523 29 27V21.1429V18.8572Z' fill='white' />
  </svg>
)
